export function toJS(instance) {
  return instance && 'toJS' in instance && typeof instance.toJS === 'function'
    ? instance.toJS()
    : instance;
}
